import React from 'react';
import PropTypes from 'prop-types';
import { ALPHABET } from 'legacy/src/utility/utils';
import cn from 'classnames';

import './LearnosityDistractor.scss';
import LearnosityText from './LearnosityText';

/**
 * Render Learnosity distractor rationale as raw html to innerHTML.
 */
const LearnosityDistractor = ({ index, html, isCorrectOption, isVisible }) => {
  return (
    <div
      className={cn('LearnosityDistractor', { '--valid': isCorrectOption })}
      hidden={!isVisible}
    >
      <h3 className="title">Answer {ALPHABET[index]}</h3>
      <LearnosityText className="content" text={html} />
    </div>
  );
};

LearnosityDistractor.propTypes = {
  // index of distractor in array
  index: PropTypes.number.isRequired,
  // raw html from Learnosity
  html: PropTypes.string.isRequired,
  // tell if an option is correct, show green "Correct" information
  isCorrectOption: PropTypes.bool.isRequired,
};

export default LearnosityDistractor;
